export default function persist (key, value) {
  if (window.localStorage[key]) {
    let mongos = JSON.parse(window.localStorage[key])
    mongos = {...mongos, ...value}
    window.localStorage.setItem(key, JSON.stringify(mongos))
  } else {
    window.localStorage.setItem(key, JSON.stringify(value))
  }
}



// WEBPACK FOOTER //
// ./src/utils/persist.js